<template>
<div>
  <AppHeader title="Cashier Cash" />
    <div class="container">
    <div class="container left">
      <div class="row" style="padding-left: 15px">
        <!-- <div class="col-sm-1">
          <div
            class="dropdown"
            style="
              position: fixed;
              left: 0;
              top: 0;
              padding: 0;
              margin-top: 0;
              margin-bottom: 0;
            "
          >
            <ReportsMenu />
          </div>
        </div> -->
        <div class="col-sm-11">
          <br />
          <br />
          <div class="col-sm-2" style="text-align: right">
            <label title="Date" style="font-size: 1.5em; color: white"
              >Date:</label
            >
          </div>
          <div>
            <div class="col-sm-2" style="text-align: center">
              <datepicker
                v-model="state.date"
                name="selected_date"
                format="yyyy-MM-dd"
                @selected="parentfunctionSelectedhandler"
                @opened="datepickerOpenedFunction"
                @closed="parentfunctionCloseHandler"
              ></datepicker>
            </div>
          </div>
          <div class="col-sm-2" style="text-align: center">
            <button
              class="btn btn-success"
              style="font-size: 1.5em; scale: 112%; margin-top: 3px"
              @click="findCashierCash()"
            >
              Find
            </button>
          </div>
        </div>
      </div>

      <br />

      <div v-if="toggle">
        <div style="text-align: right">
          <button
            class="btn btn-success"
            style="font-size: 1.5em"
            @click="printReport()"
          >
            Print
          </button>
        </div>

        <div
          class="row table-wrap"
          style="
            color: #fff;
            
            max-height: 450px;
            overflow-y: auto;
          "
        >
          <table class="table" style="color: #fff">
            <thead>
              <tr>
                <th
                  style="
                    font-size: 1.5em;
                    text-align: right;
                    background-color: black;
                  "
                >
                  Cashier Name
                </th>
                <th
                  style="
                    font-size: 1.5em;
                    text-align: right;
                    background-color: black;
                  "
                >
                  Grand Total
                </th>
                <!-- <th  style="font-size:1.5em;text-align: right;background-color: black;">System Cash</th>
                <th  style="font-size:1.5em;text-align: right;background-color: black;">Actual Cash</th> -->
                <!-- <th
                  style="
                    font-size: 1.5em;
                    text-align: right;
                    background-color: black;
                  "
                >
                  Diff
                </th> -->
                <th
                  style="
                    width: 0px;
                    font-size: 1.5em;
                    text-align: right;
                    background-color: black;
                  "
                ></th>
                <!-- <th  style="font-size:1.5em;text-align: right;background-color: black;">System Credit</th>
                <th  style="font-size:1.5em;text-align: right;background-color: black;">Actual Credit</th>
                <th  style="font-size:1.5em;text-align: right;background-color: black;">Diff</th>
                <th  style="font-size:1.5em;text-align: right;background-color: black;">System Mobile</th>
                <th  style="font-size:1.5em;text-align: right;background-color: black;">Actual Mobile</th>
                <th  style="font-size:1.5em;text-align: right;background-color: black;">Diff</th>
                <th  style="font-size:1.5em;text-align: right;background-color: black;">On Account</th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in payment_totals" :key="item.partOne">
                <td style="font-size: 1.5em; text-align: right">
                  {{ item.partOne }}
                </td>
                <td style="font-size: 1.5em; text-align: right">
                  {{ this.formatNumber(item.grandtotal) }}
                </td>
                <!-- <td style="font-size:1.5em;text-align: right;">{{this.formatNumber(item.system_cash)}}</td>
                <td style="font-size:1.5em;text-align: right;">{{this.formatNumber(item.actual_cash)}}</td> -->
                <!-- <td style="font-size: 1.5em; text-align: right">0</td> -->
                <td style="width: 0px; font-size: 1.5em; text-align: right">
                  {{}}
                </td>
                <!-- <td style="font-size:1.5em;text-align: right;">{{this.formatNumber(item.diffcash)}}</td> -->
                <button
                  class="btn btn-success"
                  style="font-size: 1.5em"
                  @click="findCashierCash_payment(item.shift_id)"
                >
                  Show Details
                </button>
                <!-- <td style="font-size:1.5em;text-align: right;">{{this.formatNumber(item.system_credit)}}</td>
                <td style="font-size:1.5em;text-align: right;">{{this.formatNumber(item.actual_credit)}}</td>
                <td style="font-size:1.5em;text-align: right;">{{this.formatNumber(item.diffcredit)}}</td>
                <td style="font-size:1.5em;text-align: right;">{{this.formatNumber(item.system_mobile)}}</td>
                <td style="font-size:1.5em;text-align: right;">{{this.formatNumber(item.actual_mobile)}}</td>
                <td style="font-size:1.5em;text-align: right;">{{this.formatNumber(item.diffmobile)}}</td>
                <td style="font-size:1.5em;text-align: right;">{{this.formatNumber(item.system_account)}}</td> -->
              </tr>
              <tr>
                <td
                  style="
                    font-size: 1.5em;
                    text-align: right;
                    background-color: black;
                  "
                >
                  <h3>Totals</h3>
                </td>
                <td
                  style="
                    font-size: 1.5em;
                    text-align: right;
                    background-color: black;
                  "
                >
                  <h3>
                    {{
                      this.formatNumber(parseFloat(grandtotal_total).toFixed(2))
                    }}
                  </h3>
                </td>
                <td
                  style="
                    font-size: 1.5em;
                    text-align: right;
                    background-color: black;
                  "
                >
                  <h3>0</h3>
                </td>
              </tr>
            </tbody>
          </table>

          <table v-if="showTable" class="table" style="color: #fff">
            <thead>
              <tr>
                <th
                  style="
                    font-size: 1.5em;
                    text-align: right;
                    background-color: black;
                  "
                ></th>
                <th
                  style="
                    font-size: 1.5em;
                    text-align: right;
                    background-color: black;
                  "
                >
                  Payment Method
                </th>
                <th
                  style="
                    font-size: 1.5em;
                    text-align: right;
                    background-color: black;
                  "
                >
                  System
                </th>

                <!-- <th  style="font-size:1.5em;text-align: right;background-color: black;">System Cash</th> -->
                <th
                  style="
                    font-size: 1.5em;
                    text-align: right;
                    background-color: black;
                  "
                >
                  Actual
                </th>
                <th
                  style="
                    font-size: 1.5em;
                    text-align: right;
                    background-color: black;
                  "
                >
                  Diff
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in shift_payment_totals" :key="item.partOne">
                <td style="font-size: 1.5em; text-align: right"></td>
                <td style="font-size: 1.5em; text-align: right">
                  {{ this.formatNumber(item.paymentType) }}
                </td>
                <!-- <td style="font-size:1.5em;text-align: right;">{{this.formatNumber(item.grandtotal)}}</td> -->
                <td style="font-size: 1.5em; text-align: right">
                  {{ this.formatNumber(item.total_amount) }}
                </td>
                <td style="font-size: 1.5em; text-align: right">
                  {{ this.formatNumber(item.closepayment) }}
                </td>
                <td style="font-size: 1.5em; text-align: right">
                  {{ this.formatNumber(item.closepayment - item.total_amount) }}
                </td>
              </tr>
              <tr>
                <td
                  style="
                    font-size: 1.5em;
                    text-align: right;
                    background-color: black;
                  "
                >
                  <h3>Totals</h3>
                </td>
                <td
                  style="
                    font-size: 1.5em;
                    text-align: right;
                    background-color: black;
                  "
                >
                  <h3>{{}}</h3>
                </td>
                <!-- <td style="font-size:1.5em;text-align: right;background-color: black;"><h3>{{this.formatNumber(parseFloat(grandtotal_total).toFixed(2))}}</h3></td> -->
                <td
                  style="
                    font-size: 1.5em;
                    text-align: right;
                    background-color: black;
                  "
                >
                  <h3>{{ this.formatNumber(this.total_amount_total) }}</h3>
                </td>
                <td
                  style="
                    font-size: 1.5em;
                    text-align: right;
                    background-color: black;
                  "
                >
                  <h3>{{ this.formatNumber(this.closepayment_total) }}</h3>
                </td>
                <td
                  style="
                    font-size: 1.5em;
                    text-align: right;
                    background-color: black;
                  "
                >
                  <h3>{{ this.formatNumber(this.total_diff) }}</h3>
                </td>
              </tr>
            </tbody>
          </table>

          <hr />
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import axios from "axios";
import commonServices from "@/shared/commonServices";
import ReportsMenu from "@/components/ReportsMenu";
//import DatePick from 'vue-date-pick';
import Datepicker from "vuejs3-datepicker";
import AppHeader from "@/components/AppHeader";
import "vue-date-pick/dist/vueDatePick.css";
export default {
  mixins: [commonServices],
  mounted() {
    const nowDate = new Date();
    let year = nowDate.getFullYear();
    let month = nowDate.getMonth();
    let day = nowDate.getDate();
    this.state.date = new Date(year + "", month + "", day + "");
    this.daydate = this.state.date;
    if (localStorage.userId === undefined) {
      this.$router.push({ name: "login" });
    }
    this.language = "ar";
    this.handleLanguage();
    if (localStorage.reports_ok === "1") {
      this.reports_ok = true;
    }
    this.logoImage =
      '<img src="' + this.logoUrl + '" width="70" height="50" alt="Logo">';
  },
  components: { AppHeader, Datepicker },
  data: function () {
    return {
      showTable: false,
      grandtotal_total: 0,
      system_cash_total: 0,
      actual_cash_total: 0,
      diffcash_total: 0,
      system_credit_total: 0,
      actual_credit_total: 0,
      diffcredit_total: 0,
      total_diff: 0,
      closepayment_total: 0,
      total_amount_total: 0,
      system_mobile_total: 0,
      actual_mobile_total: 0,
      diffmobile_total: 0,
      system_account_total: 0,

      state: { date: new Date(2016, 9, 16) },
      users: [],
      usersJson: {},
      reports_ok: false,
      select_all: false,
      dailySales: [],
      showError: false,
      logoImage: "",
      total_sales: [],
      payment_totals: [],
      shift_payment_totals: [],
      userSalesPaymentJson: {},
      mainErrorMsg: "",
      logoUrl: "",
      user_name: "",
      payment_total_amount: "",
      totalSalesAmount: "",
      jsonData: {},
      language: "en",
      languageName: "",
      toggle: false,
      orderDate: "",
      daydate: "",
      paid_by: 0,
    };
  },
  methods: {
    parentfunctionSelectedhandler() {},
    datepickerOpenedFunction() {},
    parentfunctionCloseHandler() {},
    findCashierCash: async function () {
      this.daydate = this.state.date;

      this.userSalesPaymentJson.appId = localStorage.appId;
      this.userSalesPaymentJson.orderDate = this.dateToYMD(this.state.date);
      try {
        let dataURL = this.apiURL + "GiftCard/findCashierCash";
        let response = await axios.post(dataURL, this.userSalesPaymentJson);
        if (response.data.status === "success") {
          this.payment_totals = response.data.results.daily_totals;
          this.grandtotal_total = response.data.results.grandtotal_total;
          this.system_cash_total = response.data.results.system_cash_total;
          this.actual_cash_total = response.data.results.actual_cash_total;
          this.diffcash_total = response.data.results.diffcash_total;
          this.system_credit_total = response.data.results.system_credit_total;
          this.actual_credit_total = response.data.results.actual_credit_total;
          this.diffcredit_total = response.data.results.diffcredit_total;
          this.system_mobile_total = response.data.results.system_mobile_total;
          this.actual_mobile_total = response.data.results.actual_mobile_total;
          this.diffmobile_total = response.data.results.diffmobile_total;

          this.system_account_total =
            response.data.results.system_account_total;

          this.toggle = true;
        }
      } catch (error) {
        console.log(error);
      }
    },

    findCashierCash_payment: async function (id) {
      this.showTable = !this.showTable;
      this.daydate = this.state.date;

      this.userSalesPaymentJson.appId = localStorage.appId;
      this.userSalesPaymentJson.shift_id = id;
      this.userSalesPaymentJson.orderDate = this.dateToYMD(this.state.date);
      try {
        let dataURL = this.apiURL + "GiftCard/findCashierCash_payment";
        let response = await axios.post(dataURL, this.userSalesPaymentJson);
        if (response.data.status === "success") {
          this.shift_payment_totals = response.data.results.daily_totals;
          this.total_amount_total = response.data.results.total_amount_total;
          this.closepayment_total = response.data.results.closepayment_total;
          this.total_diff = this.closepayment_total - this.total_amount_total;

          this.toggle = true;
        }
      } catch (error) {
        console.log(error);
      }
    },

    printReport() {
      const nowDate = new Date();
      let year = nowDate.getFullYear();
      let month = nowDate.getMonth() + 1;
      let day = nowDate.getDate();
      let reportDate = year + "-" + month + "-" + day;
      var today = new Date();
      var time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      let reportHeader = "";
      let reportFooter =
        "Printed on: " + year + "-" + month + "-" + day + " " + time;
      this.printUserSalesPaymentReport(
        reportDate,
        reportHeader,
        reportFooter,
        this.payment_totals,
        this.grandtotal_total,
        this.system_cash_total,
        this.actual_cash_total,
        this.diffcash_total,
        this.system_credit_total,
        this.actual_credit_total,
        this.diffcredit_total,
        this.system_mobile_total,
        this.actual_mobile_total,
        this.diffmobile_total,
        this.system_account_total
      );
    },
    printUserSalesPaymentReport(
      reportDate,
      reportHeader,
      reportFooter,
      payment_totals,
      grandtotal_total,
      system_cash_total,
      actual_cash_total,
      diffcash_total,
      system_credit_total,
      actual_credit_total,
      diffcredit_total,
      system_mobile_total,
      actual_mobile_total,
      diffmobile_total,
      system_account_total
    ) {
      let self = this;
      let viaInvStr = '<table width="100%">';
      viaInvStr = viaInvStr + "<tr><td>";
      viaInvStr = viaInvStr + "<tr><td>";
      viaInvStr =
        viaInvStr +
        '<table align="center" width="100%"  style="border-bottom: #000000 2px solid; vertical-align:bottom"><tr><td  align="center" style="vertical-align:bottom"><b><p style="font-size:1.5em">' +
        reportHeader +
        "</p></b></td></tr></table>";
      viaInvStr = viaInvStr + "</td></tr>";
      viaInvStr = viaInvStr + "<tr><td>";
      viaInvStr =
        viaInvStr +
        '<table align="left" width="100%"  style="border-bottom: #000000 2px solid;"><tr><td align="left" ><b><p style="font-size:1.5em">Date:</p></b></td><td align="left"><b><p style="font-size:1.5em">' +
        reportDate +
        "</p></b></td></tr></table>";
      viaInvStr = viaInvStr + "</td></tr>";
      viaInvStr = viaInvStr + "<tr><td>";
      viaInvStr = viaInvStr + '<table align="left" width="100%">';
      viaInvStr =
        viaInvStr +
        '<tr><td align="left"><b><p style="font-size:1.5em">Cashier Name</p></b></td>';
      viaInvStr =
        viaInvStr +
        '<td align="right"><b><p style="font-size:1.5em">Grand Total</p></b></td>';
      viaInvStr =
        viaInvStr +
        '<td align="right"><b><p style="font-size:1.5em">System Cash</p></b></td>';
      viaInvStr =
        viaInvStr +
        '<td align="right"><b><p style="font-size:1.5em">Actual Cash</p></b></td>';
      viaInvStr =
        viaInvStr +
        '<td align="right"><b><p style="font-size:1.5em">Cash Diff</p></b></td>';
      viaInvStr =
        viaInvStr +
        '<td align="right"><b><p style="font-size:1.5em">System Credit</p></b></td>';
      viaInvStr =
        viaInvStr +
        '<td align="right"><b><p style="font-size:1.5em">Actual Credit</p></b></td>';
      viaInvStr =
        viaInvStr +
        '<td align="right"><b><p style="font-size:1.5em">Credit Diff</p></b></td>';
      viaInvStr =
        viaInvStr +
        '<td align="right"><b><p style="font-size:1.5em">System Mobile</p></b></td>';
      viaInvStr =
        viaInvStr +
        '<td align="right"><b><p style="font-size:1.5em">Actual Mobile</p></b></td>';
      viaInvStr =
        viaInvStr +
        '<td align="right"><b><p style="font-size:1.5em">Mobile Diff</p></b></td>';
      viaInvStr =
        viaInvStr +
        '<td align="right"><b><p style="font-size:1.5em">On Account</p></b></td>';
      viaInvStr = viaInvStr + "</tr>";
      payment_totals.forEach(function (item) {
        viaInvStr = viaInvStr + "<tr>";
        viaInvStr =
          viaInvStr +
          '<td align="left"><p style="font-size:1.5em">' +
          item.partOne +
          "</p></td>";
        let grandtotal = 0;
        if (item.grandtotal !== null) grandtotal = item.grandtotal;
        viaInvStr =
          viaInvStr +
          '<td align="right"><p style="font-size:1.5em">' +
          self.formatNumber(grandtotal) +
          "</p></td>";
        let system_cash = 0;
        if (item.system_cash !== null) system_cash = item.system_cash;
        viaInvStr =
          viaInvStr +
          '<td align="right"><p style="font-size:1.5em">' +
          self.formatNumber(system_cash) +
          "</p></td>";
        let actual_cash = 0;
        if (item.actual_cash !== null) actual_cash = item.actual_cash;
        viaInvStr =
          viaInvStr +
          '<td align="right"><p style="font-size:1.5em">' +
          self.formatNumber(actual_cash) +
          "</p></td>";
        let diffcash = 0;
        if (item.diffcash !== null) diffcash = item.diffcash;
        viaInvStr =
          viaInvStr +
          '<td align="right"><p style="font-size:1.5em">' +
          self.formatNumber(diffcash) +
          "</p></td>";
        let system_credit = 0;
        if (item.system_credit !== null) system_credit = item.system_credit;
        viaInvStr =
          viaInvStr +
          '<td align="right"><p style="font-size:1.5em">' +
          self.formatNumber(system_credit) +
          "</p></td>";
        let actual_credit = 0;
        if (item.actual_credit !== null) actual_credit = item.actual_credit;
        viaInvStr =
          viaInvStr +
          '<td align="right"><p style="font-size:1.5em">' +
          self.formatNumber(actual_credit) +
          "</p></td>";
        let diffcredit = 0;
        if (item.diffcredit !== null) diffcredit = item.diffcredit;
        viaInvStr =
          viaInvStr +
          '<td align="right"><p style="font-size:1.5em">' +
          self.formatNumber(diffcredit) +
          "</p></td>";

        let system_mobile = 0;
        if (item.system_mobile !== null) system_mobile = item.system_mobile;
        viaInvStr =
          viaInvStr +
          '<td align="right"><p style="font-size:1.5em">' +
          self.formatNumber(system_mobile) +
          "</p></td>";
        let actual_mobile = 0;
        if (item.actual_mobile !== null) actual_mobile = item.actual_mobile;
        viaInvStr =
          viaInvStr +
          '<td align="right"><p style="font-size:1.5em">' +
          self.formatNumber(actual_mobile) +
          "</p></td>";
        let diffmobile = 0;
        if (item.diffmobile !== null) diffmobile = item.diffmobile;
        viaInvStr =
          viaInvStr +
          '<td align="right"><p style="font-size:1.5em">' +
          self.formatNumber(diffmobile) +
          "</p></td>";

        let system_account = 0;
        if (item.system_account !== null) system_account = item.system_account;
        viaInvStr =
          viaInvStr +
          '<td align="right"><p style="font-size:1.5em">' +
          self.formatNumber(system_account) +
          "</p></td>";
        viaInvStr = viaInvStr + "</tr>";
      });
      viaInvStr =
        viaInvStr +
        '<tr><td align="left"><b><p style="font-size:1.5em">Totals</p></b></td>';
      viaInvStr =
        viaInvStr +
        '<td align="right"><b><p style="font-size:1.5em">' +
        this.formatNumber(parseFloat(grandtotal_total).toFixed(2)) +
        "</p></b></td>";
      viaInvStr =
        viaInvStr +
        '<td align="right"><b><p style="font-size:1.5em">' +
        this.formatNumber(parseFloat(system_cash_total).toFixed(2)) +
        "</p></b></td>";
      viaInvStr =
        viaInvStr +
        '<td align="right"><b><p style="font-size:1.5em">' +
        this.formatNumber(parseFloat(actual_cash_total).toFixed(2)) +
        "</p></b></td>";
      viaInvStr =
        viaInvStr +
        '<td align="right"><b><p style="font-size:1.5em">' +
        this.formatNumber(parseFloat(diffcash_total).toFixed(2)) +
        "</p></b></td>";
      viaInvStr =
        viaInvStr +
        '<td align="right"><b><p style="font-size:1.5em">' +
        this.formatNumber(parseFloat(system_credit_total).toFixed(2)) +
        "</p></b></td>";
      viaInvStr =
        viaInvStr +
        '<td align="right"><b><p style="font-size:1.5em">' +
        this.formatNumber(parseFloat(actual_credit_total).toFixed(2)) +
        "</p></b></td>";
      viaInvStr =
        viaInvStr +
        '<td align="right"><b><p style="font-size:1.5em">' +
        this.formatNumber(parseFloat(diffcredit_total).toFixed(2)) +
        "</p></b></td>";
      viaInvStr =
        viaInvStr +
        '<td align="right"><b><p style="font-size:1.5em">' +
        this.formatNumber(parseFloat(system_mobile_total).toFixed(2)) +
        "</p></b></td>";
      viaInvStr =
        viaInvStr +
        '<td align="right"><b><p style="font-size:1.5em">' +
        this.formatNumber(parseFloat(actual_mobile_total).toFixed(2)) +
        "</p></b></td>";
      viaInvStr =
        viaInvStr +
        '<td align="right"><b><p style="font-size:1.5em">' +
        this.formatNumber(parseFloat(diffmobile_total).toFixed(2)) +
        "</p></b></td>";
      viaInvStr =
        viaInvStr +
        '<td align="right"><b><p style="font-size:1.5em">' +
        this.formatNumber(parseFloat(system_account_total).toFixed(2)) +
        "</p></b></td>";
      viaInvStr = viaInvStr + "</tr>";
      viaInvStr = viaInvStr + "</td></tr>";
      viaInvStr = viaInvStr + "</table>";

      //viaInvStr = viaInvStr + '<tr><td>';
      //viaInvStr = viaInvStr + '<table align="center" width="100%"  style="border-bottom: #000000 2px solid; vertical-align:bottom"><tr><td width="100%" align="center" style="vertical-align:bottom"><b><p style="font-size:1.5em">'+reportFooter+'</p></b></td></tr></table>';
      //viaInvStr = viaInvStr + '</td></tr>';

      viaInvStr = viaInvStr + "</table>";
      this.sharedPrintElemmRep(viaInvStr);
    },
  },
};
</script>
<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  margin-top: 20px;
}

.glyphicon.glyphicon-ok {
  font-size: 30px;
}

.button {
  font: bold 15px Arial;
  text-decoration: none;
  background-color: #eeeeee;
  color: #333333;
  /* padding: 2px 6px 2px 6px;
  border-top: 1px solid #cccccc;
  border-right: 1px solid #333333;
  border-bottom: 1px solid #333333;
  border-left: 1px solid #cccccc; */
}
.grid-container-element {
  display: grid;
  grid-template-columns: 5fr 1.5fr 1.5fr 1.5fr 0.5fr;
  grid-gap: 10px;
  border: 1px solid whitesmoke;
  border-left: 0px;
  border-right: 0px;
  border-top: 0px;
  width: 100%;
}
.grid-child-element_ {
  margin: 10px;
  border: 1px solid red;
}
.grid-child-element {
  margin: 2px;
  border-left: 0px;
  border-right: 0px;
  border-top: 0px;
  padding: 0 px;
}
</style>
